module.exports = __webpack_public_path__ + "media/recipes/137-66adf2a3.png";